import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
const STATS = [{
  value: '99.4%',
  label: 'Average purity, all batches'
}, {
  value: '100%',
  label: 'Batches independently tested'
}, {
  value: '24h',
  label: 'UK dispatch window'
}, {
  value: '2–8°C',
  label: 'Cold-chain storage range'
}];
export function ScienceSection() {
  return <section id="science" className="w-full py-20 lg:py-28 border-t border-border" data-id="element-623">
      <div className="container mx-auto" data-id="element-624">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start" data-id="element-625">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5
        }} data-id="element-626">
            <p className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium mb-3" data-id="element-627">
              The science, simply
            </p>
            <h2 className="text-3xl lg:text-5xl font-semibold tracking-[-0.025em] text-foreground leading-[1.05]" data-id="element-628">
              Short chains of amino acids. Big signal
              <span className="text-primary" data-id="element-629">.</span>
            </h2>
            <div className="mt-6 space-y-4 text-[16px] leading-relaxed text-muted-foreground max-w-xl" data-id="element-630">
              <p data-id="element-631">
                Peptides are short chains of amino acids — the same building
                blocks your body already uses. They act as signalling molecules,
                telling cells what to do.
              </p>
              <p data-id="element-632">
                The quality of a peptide is determined by its{' '}
                <span className="text-foreground font-medium" data-id="element-633">purity</span> —
                the percentage of the desired molecule versus contaminants.
                Anything less than
                <span className="font-mono text-foreground" data-id="element-634"> 99%</span> isn't
                research-grade.
              </p>
              <p data-id="element-635">
                That's why we publish the certificate for every batch. The lab —
                not us — tells you what's in the vial.
              </p>
            </div>
            <div className="mt-8" data-id="element-636">
              <Button variant="outline" className="rounded-full" data-id="element-637">
                Read the science
                <ArrowRight className="h-4 w-4 ml-1" strokeWidth={2} data-id="element-638" />
              </Button>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="grid grid-cols-2 gap-px bg-border rounded-2xl overflow-hidden border border-border" data-id="element-639">
            {STATS.map(s => <div key={s.label} className="bg-card p-7 lg:p-10" data-id="element-640">
                <div className="font-mono text-3xl lg:text-5xl font-medium text-foreground tracking-tight" data-id="element-641">
                  {s.value}
                </div>
                <div className="mt-3 text-[12px] uppercase tracking-wider text-muted-foreground font-medium leading-snug" data-id="element-642">
                  {s.label}
                </div>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}